import { httpClient } from "../client";
import { GetVolunteerResponse } from "./types";

export class VolunteerApi {
    async getVolunteer(eventId: string): Promise<GetVolunteerResponse> {
        return httpClient.get<GetVolunteerResponse>(`/flagbageasy/flagbagvolunteer/managed-station-volunteers`, {
            eventId, decrypted: true,
        });
    }
}